'use strict';

angular.module('far.models.campDiscount', [])
    .service('campDiscount', function ($log, $http) {
        this.new = function (data) {
            return new CampDiscount(data);
        };

        this.get = function (discountId, callback) {
            var discount = new CampDiscount({});
            $http.get(Routing.generate('api_get_camp_discount', {campDiscount: discountId}))
                .then(function (response) {
                    discount.update(response.data);
                    if (typeof callback === 'function') {
                        callback(discount);
                    }
                })
                .catch(function (response) {
                    $log.error(response)
                });
            return discount;
        };

        this.delete = function (discount, callback) {
            return $http.delete(Routing.generate('api_delete_camp_discount', {campDiscount: discount.id}))
                .then(function () {
                    discount = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                })
                .catch(function (response) {
                    $log.error(response);
                });
        };

        this.restore = function (discount, callback) {
            return $http.patch(Routing.generate('api_patch_camp_discount', {id: discount.id}))
                .then(function () {
                    if (typeof callback == 'function') {
                        callback();
                    }
                })
                .catch(function (response) {
                    $log.error(response);
                });
        };

        function CampDiscount(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);
                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.id ? 'put' : 'post';
                        var url = this.id
                            ? Routing.generate('api_put_camp_discount', {campDiscount: this.id})
                            : Routing.generate('api_post_camp_discount');
                        var data = angular.merge({}, this);

                        return $http[method](url, data);
                    }
                }
            });
        }
    });
